module.exports = __webpack_public_path__ + "img/drkrwuwc.c7cba15d.svg";